import gql from "graphql-tag";

export default gql`
  mutation createPublicComment(
    $listingId: Int!
    $userId: Int!
    $content: String!
    $parentCommentId: Int
  ) {
    createPublicComment(
      input: {
        publicComment: {
          listingId: $listingId
          userId: $userId
          content: $content
          parentCommentId: $parentCommentId
        }
      }
    ) {
      publicComment {
        id
        listingId
        userId
        parentCommentId
        content
        createdAt
        updatedAt
        userByUserId {
          id
          firstname
          lastname
          profilePictureUrl
        }
      }
    }
  }
`;
